//__________ Get Siblings __________
function getSiblings(el, filter) {
    let siblings = [];
    el = el.parentNode.firstChild;
    do { if (!filter || filter(el)) siblings.push(el); } while (el = el.nextSibling);
    return siblings;
}

function hasParent(el, parent) {
    let current = el;

    do {
        if (current === parent) {
            return true;
        }
    }
    while (current = current.parentNode);

    return false;
}

//__________ Maybe mobile behaviour __________
//<editor-fold desc="Maybe Mobile Behaviour">
let probablyMobile = false,
    maybeMobileTimeout = null,
    $menuToggleButton = document.querySelector('header#layout-header div.navTop button.menuButton')
;

let _resize = function (event) {
    if (maybeMobileTimeout) {
        window.clearTimeout(maybeMobileTimeout);
        maybeMobileTimeout = null;
    }

    maybeMobileTimeout = window.setTimeout(function () {
        let originalValue = probablyMobile;
        probablyMobile = $menuToggleButton.getBoundingClientRect().height > 0;

        if (originalValue !== probablyMobile) {
            document.dispatchEvent(new Event('hertz.viewport.change'));
        }

    }, 100);

};

window.addEventListener('resize', _resize);
_resize();

window._isProbablyMobile = function() {
    return probablyMobile;
};

let viewportSizeUpdate = null;
let $viewportIndicator = document.querySelector('.viewportIndicator');
let windowSize = "test";

let _viewportUpdate = function() {
    // do the stuff
    windowSize = window.getComputedStyle($viewportIndicator, null).getPropertyValue('content');
    windowSize = windowSize.replace(/(^"|"$)/g, '');
};

let _delayedViewportUpdate = function (event) {
    if (viewportSizeUpdate) {
        window.clearTimeout(viewportSizeUpdate);
        viewportSizeUpdate = null;
    }

    viewportSizeUpdate = window.setTimeout(_viewportUpdate, 100);
};

window.addEventListener('resize', _delayedViewportUpdate);
_viewportUpdate();
//</editor-fold>


//__________ Tab Contain __________
//<editor-fold desc="Contain Tabs behaviour">
let $currentTabContainer = null;

let tabContainEvent = function(event) {
    let key = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;
    if (key !== 9) {
        return;
    }

    if (!hasParent(event.srcElement, $currentTabContainer)) {
        let $target = $currentTabContainer.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        $target.focus();
    }
};

let _containTabSwitching = function($element) {
    $currentTabContainer = $element;
    document.querySelector('body').addEventListener('keyup', tabContainEvent);
};

let _unlockTabSwitching = function() {
    $currentTabContainer = null;
    document.querySelector('body').removeEventListener('keyup', tabContainEvent);
};
//</editor-fold>

module.exports = {
    getViewportSize: () => windowSize,
    isProbablyMobile: () => probablyMobile,
    containTabSwitching: ($element) => _containTabSwitching($element),
    unlockTabSwitching: () => _unlockTabSwitching(),
};